import React, { useEffect, useState } from 'react';
import './CommonStyles.css';
import './ViewStockAdjustmentModalStyles.css';
import apiService from '../../services/api';

const ViewStockAdjustmentModal = ({ adjustment, onClose }) => {
    const [details, setDetails] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchDetails = async () => {
            if (!adjustment?.id) return;
            try {
                setLoading(true);
                // Try to fetch full details if adjustment doesn't have lines
                if (!adjustment.stock_adjustment_lines) {
                    const data = await apiService.getStockAdjustmentDetails(adjustment.id);
                    setDetails(data.data || data || adjustment);
                } else {
                    setDetails(adjustment);
                }
            } catch (err) {
                console.error('Failed to fetch adjustment details', err);
                setDetails(adjustment); // Fallback to passed adjustment
            } finally {
                setLoading(false);
            }
        };
        fetchDetails();
    }, [adjustment]);

    if (!adjustment) return null;

    const formatCurrency = (amount) => {
        return `$ ${parseFloat(amount || 0).toFixed(2)}`;
    };

    // Use details if available, otherwise fallback to adjustment
    const data = details || adjustment;
    const products = data.stock_adjustment_lines || data.products || [];

    return (
        <div className="modal-overlay">
            <div className="modal-container" style={{ maxWidth: '900px', width: '95%' }}>
                <div className="modal-header">
                    <h2>Stock Adjustment Details (Ref: {data.refNo || data.ref_no})</h2>
                    <button className="modal-close-btn" onClick={onClose}>✕</button>
                </div>
                
                <div className="modal-content stock-adjustment-details">
                    {loading ? (
                        <div style={{ padding: '3rem', textAlign: 'center' }}>
                            <div className="loading-spinner"></div>
                            <p style={{ marginTop: '1rem', color: '#64748b' }}>Loading adjustment details...</p>
                        </div>
                    ) : (
                        <>
                            <div className="details-header-info">
                                <div className="info-column">
                                    <h4>Reference No:</h4>
                                    <p>{data.refNo || data.ref_no}</p>
                                </div>
                                <div className="info-column">
                                    <h4>Date:</h4>
                                    <p>{data.date || data.transaction_date}</p>
                                </div>
                                <div className="info-column">
                                    <h4>Business Location:</h4>
                                    <p>{data.location || data.business_location?.name || 'Main Location'}</p>
                                </div>
                                <div className="info-column">
                                    <h4>Adjustment Type:</h4>
                                    <span className={`adjustment-type-badge ${data.type || data.adjustment_type}`}>
                                        {data.type || data.adjustment_type}
                                    </span>
                                </div>
                            </div>

                            <div className="adjustment-products-section">
                                <h3><i className="fa fa-cubes"></i> Adjusted Products</h3>
                                <div className="invoice-table-wrapper">
                                    <table className="adjustment-products-table">
                                        <thead>
                                            <tr>
                                                <th>#</th>
                                                <th>Product</th>
                                                <th>Quantity</th>
                                                <th>Unit Price</th>
                                                <th>Subtotal</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {products.length === 0 ? (
                                                <tr>
                                                    <td colSpan="5" style={{ textAlign: 'center', padding: '2rem', color: '#94a3b8' }}>No products found in this adjustment.</td>
                                                </tr>
                                            ) : (
                                                products.map((p, idx) => (
                                                    <tr key={idx}>
                                                        <td>{idx + 1}</td>
                                                        <td>
                                                            <div style={{ fontWeight: '600' }}>{p.product?.name || p.name || 'Unknown Product'}</div>
                                                            <div style={{ fontSize: '0.75rem', color: '#64748b' }}>SKU: {p.product?.sku || p.sku || '--'}</div>
                                                        </td>
                                                        <td>{p.quantity} {p.unit || p.product?.unit?.actual_name || ''}</td>
                                                        <td>{formatCurrency(p.unit_price || p.purchase_price)}</td>
                                                        <td>{formatCurrency(p.subtotal || (parseFloat(p.quantity) * parseFloat(p.unit_price || p.purchase_price)))}</td>
                                                    </tr>
                                                ))
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </div>

                            <div className="adjustment-summary-section">
                                <div className="summary-reason">
                                    <h4>Reason / Notes:</h4>
                                    <p>{data.reason || data.additional_notes || 'No reason provided.'}</p>
                                </div>
                                <div className="summary-totals">
                                    <div className="total-item">
                                        <label>Total Items:</label>
                                        <span>{products.length}</span>
                                    </div>
                                    <div className="total-item">
                                        <label>Amount Recovered:</label>
                                        <span>{formatCurrency(data.amountRecovered || data.amount_recovered)}</span>
                                    </div>
                                    <div className="total-item grand-total" style={{ marginTop: '0.5rem', paddingTop: '0.5rem', borderTop: '1px solid #e2e8f0' }}>
                                        <label>Total Amount:</label>
                                        <span>{formatCurrency(data.totalAmount || data.final_total)}</span>
                                    </div>
                                </div>
                            </div>
                        </>
                    )}
                </div>

                <div className="modal-footer-actions">
                    <button className="control-btn-primary" style={{ background: '#64748b' }} onClick={onClose}>Close</button>
                    <button className="control-btn-primary" onClick={() => window.print()}>
                        <i className="fa fa-print"></i> Print
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ViewStockAdjustmentModal;
